import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { DirectionProvider } from '@/components/ui/direction';
import { resolveLanguage } from '@/lib/languages';

function RtlProvider({ children }: { children: React.ReactNode }) {
    const { i18n } = useTranslation();
    const language = resolveLanguage(i18n.language);
    const dir = language.rtl ? 'rtl' : 'ltr';

    React.useEffect(() => {
        document.documentElement.dir = dir;
        document.documentElement.lang = language.code;
    }, [dir, language.code]);

    return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}

export { RtlProvider };
